import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { addressEqual } from '../../src';
import { useCallback, useState } from 'react';
import { useEthers } from './useEthers';
import { usePromiseTransaction } from './usePromiseTransaction';
export function connectContractToSigner(contract, options, library) {
  if (contract.signer) {
    return contract;
  }

  if (options === null || options === void 0 ? void 0 : options.signer) {
    return contract.connect(options.signer);
  }

  if (library === null || library === void 0 ? void 0 : library.getSigner()) {
    return contract.connect(library.getSigner());
  }

  throw new TypeError('No signer available in contract, options or library');
}
export function useContractFunction(contract, functionName, options) {
  var _useEthers = useEthers(),
      library = _useEthers.library,
      chainId = _useEthers.chainId;

  var _usePromiseTransactio = usePromiseTransaction(chainId, options),
      promiseTransaction = _usePromiseTransactio.promiseTransaction,
      state = _usePromiseTransactio.state;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      events = _useState2[0],
      setEvents = _useState2[1];

  var send = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var contractWithSigner,
        receipt,
        _events,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contractWithSigner = connectContractToSigner(contract, options, library);
            _context.next = 3;
            return promiseTransaction(contractWithSigner[functionName].apply(contractWithSigner, _args));

          case 3:
            receipt = _context.sent;

            if (receipt === null || receipt === void 0 ? void 0 : receipt.logs) {
              _events = receipt.logs.reduce(function (accumulatedLogs, log) {
                try {
                  return addressEqual(log.address, contract.address) ? [].concat(_toConsumableArray(accumulatedLogs), [contract.interface.parseLog(log)]) : accumulatedLogs;
                } catch (_err) {
                  return accumulatedLogs;
                }
              }, []);
              setEvents(_events);
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [contract, functionName, options, library]);
  return {
    send: send,
    state: state,
    events: events
  };
}